import './Profile.css';
import profile from '../assets/profileIcon.svg';
import love from '../assets/Favourite.svg';
import logo from '../assets/Alembic-logo.svg';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';


const ProfileDetail = ({ label, value }) => (
  <>
    {value && <div className="d-flex align-items-center rounded-5 px-4 fs-12 profile-detail-wrapper">
      {label}: {value}
    </div>}
  </>
);

export default function Profile() {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const profileDetails = [
    { label: 'Email ID', value: user?.emailId },
    { label: 'SAP Code', value: user?.sap },
    { label: 'Employee Code', value: user?.empCode },
    { label: 'HQ', value: user?.hq },
    { label: 'Region', value: user?.region },
    { label: 'Zone', value: user?.zone }
  ];

  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="dictionary-container d-flex flex-column gap-3">
      <div className="d-flex justify-content-center">
        <img src={profile} alt="Profile" className="profile-icon" />
      </div>

      <div className="d-flex justify-content-center">
        <div className="d-flex justify-content-center align-items-center rounded-5 name-wrapper">{user.empName}</div>
      </div>

      <div className="d-flex flex-column gap-3 px-2 mt-2" style={{ height: '320px', maxHeight: '50vh', overflowY: 'auto' }}>
        {profileDetails.map((detail, index) => (
          <ProfileDetail key={index} label={detail.label} value={detail.value} />
        ))}
      </div>
      <button className="profile-detail-wrapper rounded-5 px-4" onClick={handleLogout} style={{border: 'none', color: '#393F49', backgroundColor: '#FFEEED'}}>
        Logout
      </button>
      <div className='d-flex flex-column align-items-center gap-3'>
        <span style={{ fontWeight: '400', color: 'rgba(19, 19, 20, 1)' }}>Made With <img alt='love' src={love} /> from</span>
        <div><img src={logo} alt='Alembic' style={{ width: '10rem' }} /></div>
      </div>

    </div>
  );
}
